import { render, staticRenderFns } from "./GOptionalIcon.vue?vue&type=template&id=794b870c&scoped=true&"
import script from "./GOptionalIcon.vue?vue&type=script&lang=ts&"
export * from "./GOptionalIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b870c",
  null
  
)

export default component.exports